import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowDown } from 'lucide-react';

// ═══════════════════════════════════════════════════════════════════════════════
// SCROLL TO LATEST
//
// Appears only once the reader has left the bottom. Mounted inside the composer
// wrapper so it sits above the input identically on desktop (in flow) and
// mobile (fixed).
// ═══════════════════════════════════════════════════════════════════════════════

export function ScrollToLatest({ visible, onClick, pulsing = false, reduceMotion = false }) {
    return (
        <AnimatePresence initial={false}>
            {visible && (
                <motion.button
                    type="button"
                    onClick={onClick}
                    data-testid="scroll-to-latest"
                    initial={reduceMotion ? { opacity: 0 } : { opacity: 0, y: 8, scale: 0.96 }}
                    animate={{ opacity: 1, y: 0, scale: 1 }}
                    exit={reduceMotion ? { opacity: 0 } : { opacity: 0, y: 6 }}
                    transition={reduceMotion ? { duration: 0.1 } : { type: 'spring', stiffness: 260, damping: 28 }}
                    className="absolute bottom-[calc(100%+0.5rem)] left-1/2 z-30 flex -translate-x-1/2 items-center gap-1.5 rounded-full border border-white/10 bg-[#0b0b0e]/90 px-3 py-1.5 font-mono text-[10px] font-bold uppercase tracking-[0.18em] text-muted-foreground shadow-lg backdrop-blur-xl transition-colors hover:border-primary/30 hover:text-foreground"
                >
                    {pulsing && <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-primary" />}
                    <ArrowDown className="h-3 w-3" />
                    Latest
                </motion.button>
            )}
        </AnimatePresence>
    );
}

export default ScrollToLatest;
